document.addEventListener("DOMContentLoaded", () => {
    relatedContentSwiper()
    escaparateSwiper()
    historicoSwiper()
});

const historicoSwiper = () => {

    if( !document.querySelector( '.historico-swiper' ) ) {
        return
    }

    let initialSlide    = 0;
    let urlParams       = new URLSearchParams( window.location.search )
    let numberSelected  = urlParams.get( 'num_revista' )
    let slides          = document.querySelectorAll('.historico-swiper .swiper-slide')

    if( numberSelected ) {

        slides.forEach( ( slide ) => {
            let currentNumber = slide.dataset.magnumber
            if( currentNumber == numberSelected ) {
                initialSlide = slide.dataset.slidenumber
            }
        })
    }

    let historicoSwiper = new Swiper( '.historico-swiper', {
        initialSlide: initialSlide,
        effect: "coverflow",
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })

}

const escaparateSwiper = () => {

    if( !document.querySelector( '.swiperEscaparate' ) ) {
        return
    }

    let swiperEscaparate = new Swiper('.swiperEscaparate', {
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });

}

const relatedContentSwiper = () => {

    if( !document.querySelector( '.related-content-swiper' ) ) {
        return
    }

    let swiperRelatedPosts = new Swiper('.related-content-swiper', {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 23,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            970: {
                slidesPerView: 3,
            },
        }
    });
}
